import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';

import { AlertModalComponent }   from './modal.alert.component';
import { CaptureModalComponent } from './modal.capture.component';
import { LegacyModalComponent }  from './legacy-modal.component';
import { ModalService }          from './modal.service';
import { NoteModalComponent }    from './modal.note.component';
import { SharedModule }          from '../shared/shared.module';

@NgModule({
  declarations: [
    AlertModalComponent,
    CaptureModalComponent,
    LegacyModalComponent,
    NoteModalComponent
  ],
  entryComponents: [
    AlertModalComponent,
    CaptureModalComponent,
    LegacyModalComponent,
    NoteModalComponent
  ],
  imports: [
    SharedModule
  ],
  providers: [
    ModalService
  ],
  schemas: [NO_ERRORS_SCHEMA],
})
export class ModalsModule {}
